import TrafficEngagementMetric from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficEngagementMetric";

const engagementMetrics = new Set(Object.values(TrafficEngagementMetric));

export const isTrafficEngagementMetric = (metric: string): metric is TrafficEngagementMetric => {
    return engagementMetrics.has(metric as TrafficEngagementMetric);
};
